import { jsx as _jsx } from "react/jsx-runtime";
import React, { createRef } from 'react';
import ReactDOM from 'react-dom';
import { BaseNotifier } from './baseNotifier';
import BannerNotification from '../elementals/bannerNotification';
class PageBannerNotifier extends BaseNotifier {
    constructor() {
        super();
        this._containerDomNode = null;
    }
    initialize(containerRef) {
        const notificationSystem = createRef();
        this._containerDomNode = containerRef?.current;
        if (this._containerDomNode) {
            ReactDOM.render(_jsx(BannerNotification, { ref: notificationSystem }), this._containerDomNode);
        }
        super.initialize(notificationSystem);
    }
    open(options) {
        super.open(super.prepareOptions(options));
    }
    destroy() {
        const containerDomNode = super.notificationSystem?.current;
        if (containerDomNode && containerDomNode.parentNode) {
            ReactDOM.unmountComponentAtNode(containerDomNode);
        }
        super.destroy();
    }
}
export { PageBannerNotifier };
//# sourceMappingURL=pageBannerNotifier.js.map